import { useTranslation } from 'react-i18next'

import App from 'components/App'

import styles from './DialogAiAgentPopup.module.scss'

export type Props = {
  open: boolean
  onClose: () => void
  onYes: () => void
  text?: string
}

const DialogAiAgentPopup: React.FC<Props> = ({ open, onClose, onYes, text }) => {
  const { t } = useTranslation()

  return (
    <App.Dialog open={open} centered onClose={onClose}>
      <App.Flex column gap={6} className={styles.container}>
        <App.Flex column gap={3}>
          <App.Text center medium>{text || t('Click here - Let the secretary schedule an appointment for you')}</App.Text>
        </App.Flex>

        <App.Flex row center gap={4} fullWidth>
          <App.Button flex={1} outlined onClick={onClose}>
            {t('No')}
          </App.Button>
          <App.Button flex={1} onClick={onYes}>
            {t('Yes')}
          </App.Button>
        </App.Flex>
      </App.Flex>
    </App.Dialog>
  )
}

export default DialogAiAgentPopup
